<template>
  <div class="gx-order">
    <h1 class="gx-order__title">订单管理</h1>

    <!-- 筛选栏 -->
    <div class="gx-order__filter">
      <select v-model="searchData.shop_id" class="gx-order__select">
        <option value="">请选择店铺</option>
        <option v-for="s in shopOptions" :key="s.val" :value="s.val">{{ s.text }}</option>
      </select>
      <input v-model="searchData.keyword" class="gx-order__input" placeholder="商品标题/商品ID" @keyup.enter="doSearch" />
      <div class="gx-order__spacer"></div>
      <button class="gx-order__btn gx-order__btn--primary" @click="doSearch">查询</button>
      <button class="gx-order__btn" @click="resetSearch">重置</button>
    </div>

    <!-- 状态 tabs -->
    <div class="gx-order__status-tabs">
      <button
        v-for="(t, i) in statusTabs"
        :key="i"
        class="gx-order__status-tab"
        :class="{ 'gx-order__status-tab--on': pddOrderStatus === t.val }"
        @click="switchStatus(t.val)"
      >
        <span>{{ t.text }}</span>
        <span v-if="t.num > 0" class="gx-order__status-num">{{ t.num }}</span>
      </button>
    </div>

    <!-- 批量操作 -->
    <div class="gx-order__batch">
      <span class="gx-order__batch-label">已选 {{ checkList.length }} 单</span>
      <button class="gx-order__btn gx-order__btn--danger" @click="batchDelete">批量删除</button>
      <button class="gx-order__btn gx-order__btn--warn" @click="batchMarkAbnormal">标记异常单</button>
      <button class="gx-order__btn" @click="checkList = []">清空已选</button>
    </div>

    <!-- 订单卡片 -->
    <div class="gx-order__cards">
      <div v-for="(o, i) in list" :key="o.id" class="gx-order__card">
        <div class="gx-order__card-head">
          <span
            class="gx-order__checkbox"
            :class="{ 'gx-order__checkbox--on': checkList.includes(o.id) }"
            @click="toggleOne(o.id)"
          >
            <svg v-if="checkList.includes(o.id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </span>
          <span class="gx-order__card-shop">{{ o.shop_name || '--' }}</span>
          <span class="gx-order__card-no">{{ o.order_no }}</span>
          <span class="gx-order__card-time">{{ o.create_time }}</span>
          <span class="gx-order__card-spacer"></span>
          <button class="gx-order__card-ex" @click="markAbnormal(o)">设为异常单</button>
          <span class="gx-order__card-status" :style="statusStyle(o)">{{ statusText(o) }}</span>
        </div>

        <div class="gx-order__card-body">
          <div class="gx-order__card-info">
            <div class="gx-order__card-title">{{ o.name || o.product_title || '--' }}</div>
            <div class="gx-order__card-sub">{{ o.exchange_product_spec_str || o.spec || '' }}<span v-if="o.goods_id"> · ID：{{ o.goods_id }}</span></div>
            <div class="gx-order__card-grid">
              <div class="gx-order__kv">
                <span class="gx-order__kv-l">售价</span>
                <span class="gx-order__kv-v gx-order__gold">¥{{ o.order_amount }} × {{ o.item_num }}</span>
              </div>
              <div class="gx-order__kv">
                <span class="gx-order__kv-l">采购金额</span>
                <span class="gx-order__kv-v">¥{{ o.abb_purchase_amount || '--' }}</span>
              </div>
              <div class="gx-order__kv">
                <span class="gx-order__kv-l">买家留言</span>
                <span class="gx-order__kv-v">{{ o.buyer_words || '无' }}</span>
              </div>
              <div class="gx-order__kv">
                <span class="gx-order__kv-l">货损金额</span>
                <span class="gx-order__kv-v">¥{{ o.damaged_amount || '0.00' }}</span>
              </div>
            </div>
          </div>
          <div class="gx-order__card-ops">
            <button class="gx-order__card-op" @click="markAbnormal(o)">标记异常</button>
            <button class="gx-order__card-op" @click="syncOrder(o)">同步抖店</button>
            <button class="gx-order__card-op gx-order__card-op--danger" @click="deleteOrder(o)">删除</button>
          </div>
        </div>
      </div>

      <div v-if="!list.length" class="gx-order__empty">暂无订单数据</div>
    </div>

    <!-- 分页 -->
    <div class="gx-order__pager">
      <span class="gx-order__pager-total">共 {{ pageData.total }} 条</span>
      <div class="gx-order__pager-btns">
        <button class="gx-order__page" :disabled="pageData.page <= 1" @click="getList(true, pageData.page - 1)">上一页</button>
        <button v-for="n in pageNums" :key="n" class="gx-order__page" :class="{ 'gx-order__page--on': n === pageData.page }" @click="getList(true, n)">{{ n }}</button>
        <button class="gx-order__page" :disabled="pageData.page >= totalPages" @click="getList(true, pageData.page + 1)">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NewOrderManagePage',
  data() {
    return {
      searchData: { shop_id: '' },
      pddOrderStatus: '',
      list: [],
      checkList: [],
      pageData: { limit: 20, page: 1, total: 0 },
      statusTabs: [{ text: '全部订单', val: '', num: 0 }],
      shopOptions: []
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    }
  },
  created() {
    this.initFilter()
    this.getList(true)
  },
  methods: {
    ...mapActions({
      getOrderManageList: 'ucenter_order/getOrderManageList',
      getOrderManageFilterData: 'ucenter_order/getOrderManageFilterData',
      opOrderManageBatchMarkException: 'ucenter_order/opOrderManageBatchMarkException',
      opOrderManageDeleteProduct: 'ucenter_order/opOrderManageDeleteProduct',
      opOrderManageUpdateOrderAfterSale: 'ucenter_order/opOrderManageUpdateOrderAfterSale'
    }),
    initFilter() {
      this.getOrderManageFilterData({
        data: this.searchData,
        success: (res) => {
          if (res.code === 200) {
            const d = res.data
            const arr = d.arr_pdd_status || []
            this.statusTabs = [{ text: '全部订单', val: '', num: 0 }].concat(
              arr.map((s) => ({ text: s.text || s.label || ('状态' + s.val), val: s.val, num: s.num || 0 }))
            )
            this.shopOptions = (d.arr_shop || []).map((s) => ({ val: s.val ?? s.value, text: s.text || s.label }))
          }
        }
      })
    },
    switchStatus(val) {
      this.pddOrderStatus = val
      this.pageData.page = 1
      this.getList(true)
    },
    doSearch() {
      this.pageData.page = 1
      this.getList(true)
    },
    resetSearch() {
      this.searchData = { shop_id: '' }
      this.pddOrderStatus = ''
      this.pageData.page = 1
      this.getList(true)
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      const param = { limit: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      if (this.pddOrderStatus !== '') param.pdd_order_status = this.pddOrderStatus
      this.getOrderManageList({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            this.list = res.data.data || []
            this.pageData.total = res.data.total || 0
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }
      })
    },
    toggleOne(id) {
      const idx = this.checkList.indexOf(id)
      if (idx > -1) this.checkList.splice(idx, 1)
      else this.checkList.push(id)
    },
    statusText(o) {
      const t = this.statusTabs.find((s) => String(s.val) === String(o.pdd_order_status))
      return t ? t.text : (o.order_status_text || o.order_status || '--')
    },
    statusStyle(o) {
      const map = {
        '1': ['#3FB6E0', 'rgba(63,182,224,.1)', 'rgba(63,182,224,.3)'],
        '2': ['#FB923C', 'rgba(251,146,60,.1)', 'rgba(251,146,60,.3)'],
        '3': ['#4ADE80', 'rgba(74,222,128,.1)', 'rgba(74,222,128,.3)']
      }
      const [color, bg, border] = map[String(o.pdd_order_status)] || ['#4A4A6A', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.3)']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    markAbnormal(o) {
      this.$confirm('确认标记为异常订单？异常订单不参与自动采购和手动采购。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageBatchMarkException({
          data: { ids: String(o.id), state: 1 },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    batchMarkAbnormal() {
      if (!this.checkList.length) {
        this.$message.warning('请先勾选订单')
        return
      }
      this.$confirm('确认批量标记为异常订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageBatchMarkException({
          data: { ids: this.checkList.join(','), state: 1 },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.checkList = []
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    deleteOrder(o) {
      this.$confirm('确定删除该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageDeleteProduct({
          data: { ids: [o.id] },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    batchDelete() {
      if (!this.checkList.length) {
        this.$message.warning('请先勾选订单')
        return
      }
      this.$confirm('确定批量删除选中的订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opOrderManageDeleteProduct({
          data: { ids: this.checkList },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.checkList = []
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    syncOrder(o) {
      this.opOrderManageUpdateOrderAfterSale({
        data: { id: o.id },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.msg || '同步成功')
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.gx-order {
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px;
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-order__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 24px;
  font-weight: 600;
  color: #1A1A2E;
  margin: 0 0 20px;
}
.gx-order__filter {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.gx-order__select {
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid rgba(212, 169, 70, .18);
  background: #FFFFFF;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  min-width: 140px;
}
.gx-order__input {
  width: 170px;
  height: 30px;
  padding: 0 9px;
  border-radius: 6px;
  border: 1px solid rgba(212, 169, 70, .18);
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
}
.gx-order__spacer {
  flex: 1;
}
.gx-order__btn {
  height: 30px;
  padding: 0 12px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .18);
  font-size: 12px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-order__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-order__btn--danger {
  color: #F87171;
  border-color: rgba(248, 113, 113, .3);
}
.gx-order__btn--warn {
  color: #FB923C;
  border-color: rgba(251, 146, 60, .3);
}
.gx-order__status-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin-bottom: 16px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
  background: #F7F8FA;
}
.gx-order__status-tab {
  flex: 0 0 auto;
  padding: 8px 14px;
  border: none;
  border-right: 1px solid rgba(212, 169, 70, .1);
  cursor: pointer;
  background: transparent;
  font-size: 12px;
  color: #4A4A6A;
  position: relative;
  transition: all .18s;
  white-space: nowrap;
}
.gx-order__status-tab--on {
  background: #E1E5EE;
  color: #E8C778;
  font-weight: 600;
}
.gx-order__status-tab--on::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #D4A946, #E8C778);
}
.gx-order__status-num {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #6A6A8A;
  margin-left: 4px;
}
.gx-order__batch {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #F5F0E8;
  border: 2px solid #E0E0EC;
  border-radius: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
.gx-order__batch-label {
  font-size: 11px;
  color: #6A6A8A;
  margin-right: 4px;
}
.gx-order__cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}
.gx-order__card {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
  transition: border .2s, box-shadow .2s;
}
.gx-order__card:hover {
  border-color: rgba(212, 169, 70, .3);
  box-shadow: 0 6px 20px rgba(0, 0, 0, .08);
}
.gx-order__card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: rgba(10, 21, 53, .5);
  border-bottom: 1px solid rgba(212, 169, 70, .1);
  flex-wrap: wrap;
}
.gx-order__checkbox {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  background: #FFFFFF;
  border: 1.5px solid rgba(212, 169, 70, .3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.gx-order__checkbox--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border-color: transparent;
}
.gx-order__card-shop {
  font-size: 12px;
  font-weight: 600;
  color: #E8C778;
}
.gx-order__card-no {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #6A6A8A;
}
.gx-order__card-time {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #6A6A8A;
}
.gx-order__card-spacer {
  flex: 1;
}
.gx-order__card-ex {
  height: 24px;
  padding: 0 9px;
  border-radius: 5px;
  cursor: pointer;
  background: rgba(251, 146, 60, .08);
  border: 1px solid rgba(251, 146, 60, .28);
  font-size: 11px;
  color: #FB923C;
}
.gx-order__card-status {
  padding: 2px 9px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
}
.gx-order__card-body {
  display: flex;
}
.gx-order__card-info {
  flex: 1;
  padding: 14px 16px;
  min-width: 0;
}
.gx-order__card-title {
  font-size: 13px;
  font-weight: 500;
  color: #1A1A2E;
  line-height: 1.45;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-order__card-sub {
  font-size: 11px;
  color: #4A4A6A;
  margin-bottom: 10px;
}
.gx-order__card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px 24px;
}
.gx-order__kv {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.gx-order__kv-l {
  font-size: 11px;
  color: #6A6A8A;
  flex-shrink: 0;
}
.gx-order__kv-v {
  font-size: 12px;
  color: #1A1A2E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-order__gold {
  color: #D4A946;
  font-weight: 600;
}
.gx-order__card-ops {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 14px 16px 14px 12px;
  border-left: 1px solid rgba(212, 169, 70, .08);
  justify-content: center;
  min-width: 96px;
}
.gx-order__card-op {
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  background: rgba(139, 157, 195, .07);
  border: 1px solid rgba(139, 157, 195, .22);
  font-size: 12px;
  color: #4A4A6A;
  width: 100%;
  transition: all .16s;
}
.gx-order__card-op:hover {
  background: rgba(212, 169, 70, .1);
  border-color: rgba(212, 169, 70, .3);
  color: #E8C778;
}
.gx-order__card-op--danger {
  background: rgba(248, 113, 113, .07);
  border-color: rgba(248, 113, 113, .25);
  color: #F87171;
}
.gx-order__card-op--danger:hover {
  background: #F87171;
  color: #fff;
}
.gx-order__empty {
  text-align: center;
  padding: 56px 0;
  color: #6A6A8A;
  border-radius: 12px;
  background: #F7F8FA;
  border: 1px solid rgba(212, 169, 70, .1);
}
.gx-order__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gx-order__pager-total {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-order__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-order__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-order__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-order__page--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  color: #F4F6F8;
  font-weight: 700;
}
@media (max-width: 900px) {
  .gx-order__card-body {
    flex-direction: column;
  }
  .gx-order__card-ops {
    flex-direction: row;
    border-left: none;
    border-top: 1px solid rgba(212, 169, 70, .08);
  }
}
</style>
